import { PromiseCompletionSource } from "scene-manager";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { BaseSettingsView } from "../../../../common/views/BaseSettingsView";
import { PauseResourcesPackage } from "../resources/PauseResourcesPackage";
import { IDestroyOptions, Sprite } from "pixi.js";
import { PauseSceneResult } from "../PauseSceneResult";
import { SettingsModel } from "../../../../common/models/SettingsModel";
import { SettingsController } from "../../../../common/controllers/SettingsController";
import { UIButtonBase } from "../../../../common/components/UIButtonBase";

export class PauseView extends BaseSettingsView<PauseSceneResult> {
    private homeButton: UIButtonBase;
    private restartButton: UIButtonBase;

    public constructor(
        commonResources: CommonResourcesPackage,
        pauseResources: PauseResourcesPackage,
        settingsModel: SettingsModel,
        settingsController: SettingsController,
        canvasScaler: ICanvasScaler,
        operationControls: PromiseCompletionSource<PauseSceneResult>
    ) {
        super(
            commonResources,
            settingsModel,
            settingsController,
            pauseResources.assets_popups_pause_frame_png,
            canvasScaler,
            operationControls
        );

        this.closeButton.onUp.add(this.onCloseButtonClick, this);
        this.homeButton.onUp.add(this.onHomeButtonClick, this);
        this.restartButton.onUp.add(this.onRestartButtonClick, this);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.closeButton.onUp.remove(this.onCloseButtonClick, this);
        this.homeButton.onUp.remove(this.onHomeButtonClick, this);
        this.restartButton.onUp.remove(this.onRestartButtonClick, this);
        super.destroy(options);
    }

    public start(): void {
    }

    protected override build(): void {
        super.build();
        this.homeButton = new UIButtonBase({ defaultTexture: this.commonResources.assets_common_button_background_png });
        const homeIcon = new Sprite(this.commonResources.assets_common_home_icon_png);
        homeIcon.position.set(43, 31);
        this.homeButton.defaultView.addChild(homeIcon);

        this.restartButton = new UIButtonBase({ defaultTexture: this.commonResources.assets_common_button_background_png });
        const restartIcon = new Sprite(this.commonResources.assets_common_restart_icon_png);
        restartIcon.position.set(46, 31);
        this.restartButton.defaultView.addChild(restartIcon);

        this.frame.addChild(this.homeButton, this.restartButton);
    }

    protected layout(width: number, height: number): void {
        switch (height) {
            case 2400:
                this.layout9x20(width);
                break;
            case 1620:
                this.layout10x9();
                break;
            case 1800:
                this.layout4x3();
                break;
        }
        this.musicToggle.position.set(125, 74);
        this.soundToggle.position.set(404, 74);
        this.languagesBox.position.set(79, 275);
        this.homeButton.position.set(129, 641);
        this.restartButton.position.set(408, 641);
        this.closeButton.position.set(581, -64);
    }

    private layout9x20(width: number): void {
        this.frame.position.set((width - this.frame.width) * 0.5, (2400 - this.frame.width) * 0.5);
    }

    private layout10x9(): void {
        this.frame.position.set(1061, 351);
    }

    private layout4x3(): void {
        this.frame.position.set(821, 441);
    }

    private onCloseButtonClick(): void {
        this.operationControls.complete(PauseSceneResult.None);
    }

    private async onHomeButtonClick(): Promise<void> {
        await this.settingsController.showMidrollAd();
        this.operationControls.complete(PauseSceneResult.Home);
    }

    private async onRestartButtonClick(): Promise<void> {
        await this.settingsController.showMidrollAd();
        this.operationControls.complete(PauseSceneResult.Restart);
    }
}
